import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import useStyles from './makeStyles';

const Label = ({ option, specialRegions }) => {
  const classes = useStyles();
  const { i18n } = useTranslation();
  const text = option.country[`name${i18n.language.toUpperCase()}`];

  if (specialRegions[option.code]) {
    return (
      <div className={classes.root}>
        <span className={classes.icon}>{specialRegions[option.code].icon}</span>
        <p className={classes.text}>{text}</p>
      </div>
    );
  }
  return <span>{text}</span>;
};

Label.propTypes = {
  option: PropTypes.shape({
    country: PropTypes.shape({}),
    code: PropTypes.string,
  }).isRequired,
  specialRegions: PropTypes.shape({}).isRequired,
};

export default memo(Label);
